"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SounditiApi_1 = __importDefault(require("../SounditiApi"));
var Auth_1 = __importDefault(require("../Auth"));
var defaults_1 = __importDefault(require("../defaults"));
var errors_1 = require("../utils/errors");
var utils_1 = require("../utils/utils");
/**
 * Provides access to the billing options
 * @class
 *
 * @param {string} [host = defaults.host] | the api host
 *
 * @category DataLayers
 *
 * @example
 * // ====== ONE TIME PAYMENTS =========
 * // PRE REQUIREMENTS (stripe checkout)
 *
 * // TEST METHOD FOR USING WITHIN A REACT COMPONENT
 * // ADD STRIPE LIB TO REACT
 *
 *  import { loadStripe } from '@stripe/stripe-js';
 *  const stripePromise = loadStripe('STRIPE_PK_KEY');
 *
 * // in the render method call this one like:
 * // <button onClick={this.handleCheckoutClick}>PAY CAMPAIGN</button>
 *
 * handleCheckoutClick = async (event) => {
 * const { campaignID } = this.state;
 * const billingAccess = new BillingAccess()
 *    try {
 *        const { id: sessionId } = await billingAccess.payCampaign(campaignID)
 *        console.log("REPLY FROM BILLING", sessionId)
 *        // When the customer clicks on the button, redirect them to Checkout.
 *        const stripe = await stripePromise;
 *        const { error } = await stripe.redirectToCheckout({
 *            sessionId,
 *        });
 *        if(error) {
 *            // DO SOMETHING WITH STRIPE ERROR
 *        }
 *    } catch (error) {
 *    // DO SOMETHING WITH API THE ERROR
 *    }
 * };
 *
 *
*/
var BillingAccess = /** @class */ (function () {
    /**
     *
     * @param {DataLayerConfiguration} options
     * @param {host} [options.hosts = defaults] | An access token
     *
     */
    function BillingAccess(_a) {
        var _b = (_a === void 0 ? {} : _a).hosts, hosts = _b === void 0 ? defaults_1.default : _b;
        this._authRenewal = utils_1.tokenRenewal;
        this.auth = new Auth_1.default({ auth_host: hosts.auth_host });
        this.token = this.auth.getToken() || '';
        this.api = new SounditiApi_1.default({ token: this.token, hosts: hosts });
        this.table = 'campaigns';
    }
    ;
    /**
     * Retrieves a subscription list
     *
     * @param {boolean} [renew = false] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<Subscription[]>} A list of stripe charges
     *
     * @throws {BillingError} When an error occurs getting the subscriptions list
     * @throws {PermissionError} Auth token not valid
     */
    BillingAccess.prototype.getSubscriptionList = function (renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, subs, subs, e, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.getSubscriptionList()];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        subs = _a.sent();
                        return [2 /*return*/, subs];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getSubscriptionList(false)];
                    case 5:
                        subs = _a.sent();
                        return [2 /*return*/, subs];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        throw new errors_1.BillingError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_1 = _a.sent();
                        throw error_1;
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Retrieves a Stripe session id to pay some audience
     *
     * @param {PayAudienceRequest} [payAudienceRequest]
     * @param {boolean} [renew = false] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<string>} session id to pay some audience
     *
     * @throws {BillingError} When an error occurs saving the credit card
     * @throws {PermissionError} Auth token not valid
     */
    BillingAccess.prototype.payAudience = function (payAudienceRequest, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, cards, cards, e, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.payAudience(payAudienceRequest)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        cards = _a.sent();
                        return [2 /*return*/, cards];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.payAudience(payAudienceRequest, false)];
                    case 5:
                        cards = _a.sent();
                        return [2 /*return*/, cards];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        throw new errors_1.BillingError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_2 = _a.sent();
                        throw error_2;
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Retrieves a Stripe session id to pay a test
     *
     * @param {PayCampaignRequest} [payCampaignRequest]
     * @param {boolean} [renew = false] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<string>} session id to pay a test
     *
     * @throws {BillingError} When an error occurs saving the credit card
     * @throws {PermissionError} Auth token not valid
     */
    BillingAccess.prototype.payCampaign = function (payCampaignRequest, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, cards, cards, e, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.payCampaign(payCampaignRequest)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        cards = _a.sent();
                        return [2 /*return*/, cards];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.payCampaign(payCampaignRequest, false)];
                    case 5:
                        cards = _a.sent();
                        return [2 /*return*/, cards];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        throw new errors_1.BillingError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_3 = _a.sent();
                        throw error_3;
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Updates the subscription of an user
     *
     * @param {string} userId
     * @param {string} subscriptionId
     * @param {boolean} [resetTests = false]
     * @param {boolean} [resetFilms = false]
     *
     * @returns {Promise<UserItem>} UserItem
     *
     * @throws {BillingError} When an error occurs saving the credit card
     * @throws {PermissionError} Auth token not valid
     */
    BillingAccess.prototype.updateUserSubscription = function (userId, subscriptionId, resetTests, resetFilms, renew) {
        if (resetTests === void 0) { resetTests = false; }
        if (resetFilms === void 0) { resetFilms = false; }
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, cards, cards, e, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.updateUserSubscription(userId, subscriptionId, resetTests, resetFilms)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        cards = _a.sent();
                        return [2 /*return*/, cards];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.updateUserSubscription(userId, subscriptionId, resetTests, resetFilms, false)];
                    case 5:
                        cards = _a.sent();
                        return [2 /*return*/, cards];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        throw new errors_1.BillingError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_4 = _a.sent();
                        throw error_4;
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     *
     * @param requestTestersPrice
     * @returns
     */
    BillingAccess.prototype.requestTestersPrice = function (requestTestersPrice, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, cards, cards, e, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.requestTestersPrice(requestTestersPrice)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        cards = _a.sent();
                        return [2 /*return*/, cards];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.requestTestersPrice(requestTestersPrice, false)];
                    case 5:
                        cards = _a.sent();
                        return [2 /*return*/, cards];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        throw new errors_1.BillingError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_5 = _a.sent();
                        throw error_5;
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /**
     *
     * @param payTesters
     * @returns
     */
    BillingAccess.prototype.payTesters = function (payTesters, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, cards, cards, e, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.payTesters(payTesters)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        cards = _a.sent();
                        return [2 /*return*/, cards];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.payTesters(payTesters, false)];
                    case 5:
                        cards = _a.sent();
                        return [2 /*return*/, cards];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        throw new errors_1.BillingError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_6 = _a.sent();
                        throw error_6;
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    return BillingAccess;
}());
;
exports.default = BillingAccess;
//# sourceMappingURL=BillingAccess.js.map